module.exports = __webpack_public_path__ + "static/media/apple_store.04fafe92.png";